/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { EventBusModule } from "@vlinder-web/event-bus-module-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { BaseApplication } from "./base/baseApplication";
import { UnitTest } from "./unit.test";
import { StorageModule } from "@vlinder-web/storage-module-react";
import {
  AppNavigatorService,
  BreadcrumbService,
  LandingPageService,
  PrivacyPageService,
  TermsPageService,
  ProductLandingPageService,
  FHPPolicyPageService,
  MyAccountPageService,
  UsersListPageService,
  MyPoliciesDetailPageService,
  ProvisionalPoliciesPageService,
  ActualPoliciesPageService,
  SignInPageService,
  MyPayoutPageService,
  WeatherAnalyticsPageService,
  AnalyticsAPIDetailPageService,
  ArchivePolicyPageService,
  FaqPageService,
} from "../services";

import { DEFAULT_APP_CONFIG } from "../config/default.config";

export class VApplication extends BaseApplication {
  private static instance: VApplication;

  private constructor(options: any = {}) {
    super(options);

    this.setupBindings();

    //Modules
    this.initModules();

    //Services
    this.initServices();
  }

  static getInstance(options: any = {}) {
    if (!this.instance) {
      this.instance = new VApplication(options);
    }
    return this.instance;
  }

  // @ts-ignore
  async start() {
    await this.initRunLevel();
    await this.unitTest();
  }

  setupBindings() {
    //------------->>>>>--------------//
    const storageService = StorageModule.getInstance();
    // const DEFAULT_APP_CONFIG = storageService.get("appConfig", "session");
    this.configure("services.SignInPageService", {
      loginRestAPI: DEFAULT_APP_CONFIG?.servers?.rest?.loginServer?.baseURL,
      headers: DEFAULT_APP_CONFIG?.headers,
    });
    //------------->>>>>--------------//

    this.configure("services.MyAccountPageService", {
      loginRestAPI: DEFAULT_APP_CONFIG?.servers?.rest?.loginServer?.baseURL,
      headers: DEFAULT_APP_CONFIG?.headers,
    });

    //------------->>>>>--------------//
  }

  async initRunLevel() {
    const storageSrv = StorageModule.getInstance();
    // const DEFAULT_APP_CONFIG = storageSrv.get("appConfig", "session");
    //------------->>>>>--------------//
    const graphqlModule = this.getSync(
      "services.GraphqlServerModule"
    ) as GraphqlServerModule;
    if (graphqlModule) {
      type TClient = typeof DEFAULT_APP_CONFIG.servers.graphql[0];
      DEFAULT_APP_CONFIG?.servers.graphql.forEach((client: TClient) => {
        graphqlModule
          .createClient(client.name, {
            url: client.url,
            getContext: this.getGraphQLContext.bind(this),
          })
          .then((res) => {
            console.log(`initRunLevel check`, res);
          })
          .catch((err) => {
            console.log(`error in initRunLevel  ${err.message}`);
          });
      });
    }
    //------------->>>>>--------------//
    const storageService = this.getSync(
      "services.StorageModule"
    ) as StorageModule;
    await storageService.init();
  }

  async unitTest() {
    const ut = new UnitTest(VApplication);
    ut.run();
  }

  initModules() {
    this.service("services.EventBusModule", EventBusModule);
    this.service("services.GraphqlServerModule", GraphqlServerModule);
  }

  initServices() {
    this.service("services.AppNavigatorService", AppNavigatorService);
    this.service("services.BreadcrumbService", BreadcrumbService);
    this.service("services.LandingPageService", LandingPageService);
    this.service("services.PrivacyPageService", PrivacyPageService);
    this.service("services.TermsPageService", TermsPageService);
    this.service(
      "services.ProductLandingPageService",
      ProductLandingPageService
    );
    this.service("services.FHPPolicyPageService", FHPPolicyPageService);
    this.service("services.MyAccountPageService", MyAccountPageService);
    this.service("services.UsersListPageService", UsersListPageService);
    this.service(
      "services.MyPoliciesDetailPageService",
      MyPoliciesDetailPageService
    );
    this.service(
      "services.ProvisionalPoliciesPageService",
      ProvisionalPoliciesPageService
    );
    this.service(
      "services.ActualPoliciesPageService",
      ActualPoliciesPageService
    );
    this.service("services.SignInPageService", SignInPageService);
    this.service("services.MyPayoutPageService", MyPayoutPageService);
    this.service(
      "services.WeatherAnalyticsPageService",
      WeatherAnalyticsPageService
    );
    this.service(
      "services.AnalyticsAPIDetailPageService",
      AnalyticsAPIDetailPageService
    );
    this.service(
      "services.ArchivePolicyPageService",
      ArchivePolicyPageService
    );
    this.service("services.FaqPageService", FaqPageService);
  }

  private getGraphQLContext() {
    const loginService = this.getSync(
      "services.AppNavigatorService"
    ) as AppNavigatorService;
    let token = loginService?.getToken();
    //FIXME:
    if (token) {
      return {
        headers: {
          authentication: token,
          headers: {
            // ...{ ...deviceInfoService?.getDeviceInfo() },
            // ...{ ...deviceInfoService?.getAppInfo() },
          },
        },
      };
    } else {
      return {
        headers: {
          headers: {
            // ...{ ...deviceInfoService?.getDeviceInfo() },
            // ...{ ...deviceInfoService?.getAppInfo() },
          },
        },
      };
    }
  }
}
